<template>
  <div class="content">
    <div class="head_title">
      <div class="title1">为您实力甄选热销套餐</div>
      <div class="title2">品质保证，一站搞定，省心省力省钱</div>
      <div class="Scribing"></div>
    </div>
    <div class="switchmenu">
      <div
        v-for="(item,index) in menulist"
        :key="index"
        :class="isAdded == index?'menu1':'menu2'"
        @click="addCart(index)"
      >{{item.name}}</div>
    </div>
    <div class="main_bj" v-if="shows">
      <img src="../../assets/images/index/taocanbj.png" />
      <div class="whitebackground">
        <div class="bj_left">
            <img src="../../assets/images/index/299tupian.png">
        </div>
        <div class="bj_right">
          <div class="setmealtitle1">MAIN PACKAGE</div>
          <div class="setmealtitle2">质惠套餐</div>
          <div class="Price">
              <div class="Pricenum">299<span style="font-size: 30px;font-size: 30px;">元/m²</span></div>
          </div>
          <div class="describe">空间配置：客厅、卧室、阳台、厨房、卫生间</div>
        </div>
      </div>
    </div>
    <div class="main_bj" v-if="!shows">
      <img src="../../assets/images/index/taocanbj.png" />
      <div class="whitebackground">
        <div class="bj_left">
            <img src="../../assets/images/index/499tupian.png">
        </div>
        <div class="bj_right">
          <div class="setmealtitle1">MAIN PACKAGE</div>
          <div class="setmealtitle2">质享套餐</div>
          <div class="Price">
              <div class="Pricenum">499<span style="font-size: 30px;font-size: 30px;">元/m²</span></div>
          </div>
          <div class="describe">空间配置：客厅、卧室、阳台、厨房、卫生间</div>
        </div>
      </div>
    </div>
    <router-link to='Setmeal'><div class="Seemore" >查看更多</div></router-link>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {
      menulist: [{ name: "质惠套餐299" }, { name: "质享套餐499" }],
      isAdded: 0,
      shows:true
    };
  },
  methods: {
    addCart(index) {
      this.isAdded = index;
      if(index == 0){
          this.shows = true
      }else{
          this.shows = false
      }
    }
  }
};
</script>
<style scoped>
.title1 {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 3px;
  color: #333333;
  margin-top: 50px;
}
.title2 {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #666666;
}
.Scribing {
  width: 50px;
  height: 6px;
  background-color: #bc001d;
  margin: 0 auto;
  margin-top: 20px;
}
.switchmenu {
  width: 100%;
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.menu1 {
  width: 170px;
  height: 57px;
  font-size: 16px;
  line-height: 57px;
  color: #fff;
  background-color: #bc001d;
  float: left;
  position: relative;
}
.menu1:after {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #bc001d;
  content: "";
  position: absolute;
  width: 0;
  bottom: -5px;
  right: 80px;
  z-index: 100;
}
.menu2 {
  width: 170px;
  height: 57px;
  font-size: 16px;
  line-height: 57px;
  color: #fff;
  float: left;
  background: rgb(241, 239, 224);
  color: #666666;
}
.main_bj {
  width: 100%;
  position: relative;
}
.main_bj img {
  width: 100%;
}
.whitebackground {
  width: 1280px;
  height: 471px;
  background-color: #ffffff;
  box-shadow: 0px 0px 27px 0px rgba(1, 1, 1, 0.32);
  position: absolute;
  z-index: 10;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.bj_left{
    width: 50%;
    height: 100%;
    float: left;
}
.bj_left img{
    width: 588px;
    height: 557px;
    margin-top: -30px;
}
.bj_right{
    height: 100%;
    float: left;
    text-align: left;
    padding-left: 88px;
}
.setmealtitle1{
	font-family: MicrosoftYaHei-Bold;
	font-size: 46px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 2px;
	color: #333333;
	opacity: 0.4;
    margin-top: 70px;
}
.setmealtitle2{
	font-family: MicrosoftYaHei-Bold;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 2px;
	color: #333333;
}
.Price{
    margin-top: 40px;
}
.Pricenum{
    width: 100%;
	font-family: Impact;
	font-size: 100px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #bc001d;
}
.describe{
    font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 2px;
	color: #333333;
    margin-top: 66px;
}
.Seemore{
	width: 100px;
	height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #bc001d;
	border: solid 1px #bc001d;
    margin: 0 auto;
    margin-top: -80px;
    position: relative;
    z-index: 10;
}
</style>
